export default __webpack_public_path__ + "static/iq-8b3003fb968093c2f20b0e4694049261.jpg";